import styled from "styled-components";

export const Hero = styled.div(
  ({ backgroundImageMobile, backgroundImageDesktop, theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "634px",
    color: "white",
    textAlign: "center",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: `url(${backgroundImageMobile})`,
    backgroundSize: "cover",
    [theme.breakpoint.md()]: {
      backgroundImage: `url(${backgroundImageDesktop})`,
    },
  })
);

export const Content = styled.div(({ theme }) => ({
  gap: "8px",
  margin: "auto auto 60px 24px",
  textShadow: "2px 4px 4px rgba(0, 0, 0, 0.25)",

  [theme.breakpoint.md()]: {
    margin: "auto auto 100px 60px",
  },
}));

export const MainTitle = styled.h1(({ theme }) => ({
  fontWeight: 700,
  lineHeight: "40px",
  fontSize: "40px",
  textAlign: "left",
  [theme.breakpoint.md()]: {
    lineHeight: "72px",
    fontSize: "72px",
  },
}));

export const PrimarySubtitle = styled.h2(({ theme }) => ({
  fontWeight: 700,
  fontSize: "32px",
  lineHeight: "48px",
  textAlign: "left",
  [theme.breakpoint.md()]: {
    fontSize: "50px",
    lineHeight: "75px",
  },
}));

export const SecondSubtitle = styled.h2(({ theme }) => ({
  fontWeight: 500,
  textAlign: "left",
  fontSize: "20px",
  lineHeight: "30px",
  [theme.breakpoint.md()]: {
    fontSize: "40px",
    lineHeight: "60px",
  },
}));
